import { symbolToken } from '@servicetitan/react-ioc';

export interface IAuthStore {
    readonly isAuthenticated: boolean | null;
    readonly isAuthorized: boolean;
    readonly canAccessWebhooks: boolean; // temporarily added for the V2 Webhooks beta
    readonly accessToken: string;
    readonly userName: string;
    signOut(): Promise<void>;
}

export const AUTH_STORE_TOKEN = symbolToken<IAuthStore>('AUTH_STORE_TOKEN');
